export default __webpack_public_path__ + "static/media/coder.41e0329d.png";